class SecondaryNavWeddingShopData {
  constructor(userContext, weddingShopCategoryItems) {
    this.userContext = userContext;
    this.weddingShopCategoryItems = weddingShopCategoryItems;
    this.createSubCategory = this.createSubCategory.bind(this);
  }

  getItems() {
    return this.weddingShopNavItemsNew();
  }

  createSubCategory(categories) {
    return categories.map((category) => {
      const giftsAndFavors = category.path === '/shop/category/wedding-gifts-favors';
      const intimates = category.path === '/shop/category/wedding-intimates';
      const partySupplies = category.path === '/shop/category/party-supplies-decor';
      const beautyAndWellness = category.path === '/shop/category/health-wellness';
      const identifier = category.path.substring(category.path.lastIndexOf('/') + 1);
      const categoryItem = {
        identifier,
        text: category.title,
        path: category.path,
        dropdownItems: category.children,
        showCaret: false,
        dockRight: giftsAndFavors || intimates || partySupplies || beautyAndWellness,
        parent: 'Boutique',
      };
      return categoryItem;
    });
  }

  weddingShopNavItemsNew() {
    const weddingShopNav = [
      {
        identifier: 'new-arrivals',
        text: 'New Arrivals',
        path: '/shop/collection/wedding-shop-new-arrivals',
        parent: 'Boutique',
      },
    ];
    if (this.weddingShopCategoryItems) {
      if (this.weddingShopCategoryItems.categories) {
        return weddingShopNav.concat(
          this.createSubCategory(this.weddingShopCategoryItems.categories)
        );
      }
    }
    return [];
  }

  weddingShopNavItems() {
    return [
      {
        identifier: 'new-arrivals',
        text: 'New Arrivals',
        path: '/shop/collection/wedding-shop-new-arrivals',
      },
      {
        identifier: 'bridal-boutique',
        text: 'Bridal Boutique',
        path: '/shop/category/bridal-boutique',
      },
      {
        identifier: 'wedding-party-attire',
        text: 'Wedding Party Attire',
        path: '/shop/category/wedding-party-attire',
      },
      {
        identifier: 'wedding-gifts-favors',
        text: 'Gifts & Favors',
        path: '/shop/category/wedding-gifts-favors',
      },
      {
        identifier: 'party-supplies-decor',
        text: 'Party Supplies & Decor',
        path: '/shop/category/party-supplies-decor',
      },
      {
        identifier: 'wedding-shop-accessories',
        text: 'Accessories',
        path: '/shop/category/wedding-shop-accessories',
      },
      {
        identifier: 'wedding-jewelry',
        text: 'Jewelry',
        path: '/shop/category/wedding-jewelry',
      },
      {
        identifier: 'wedding-intimates',
        text: 'Intimates',
        path: '/shop/category/wedding-intimates',
      },
      {
        identifier: 'beauty-wellness',
        text: 'Beauty & Wellness',
        path: '/shop/category/health-wellness',
      },
    ];
  }
}

export default SecondaryNavWeddingShopData;
